// constants for DataSmartTable
export const COLUMN_RESIZE_FACTOR = 2.5;
export const HEADER_THEME = "super-app-theme--header";
export const TABLE_ROWS = 15;
export const TABLE_ROW_HEIGHT = 26;
export const TABLE_MAX_ROW_EXPANSION_PANEL_HEIGHT = 390;

export const FIFTY = 50;
export const SIXTY = 60;
export const EIGHTY = 80;
export const ONE_HUNDRED = 100;
export const ONE_HUNDRED_TEN = 110;
export const ONE_HUNDRED_TWENTY = 120;
export const ONE_HUNDRED_THIRTY = 130;
export const ONE_HUNDRED_THIRTY_THREE = 133;
export const ONE_HUNDRED_THIRTY_FIVE = 135;
export const ONE_HUNDRED_FORTY = 140;
export const ONE_HUNDRED_FIFTY = 150;
export const ONE_HUNDRED_FIFTY_FIVE = 155;
export const ONE_HUNDRED_SIXTY = 160;
export const ONE_HUNDRED_SEVENTY = 170;
export const ONE_HUNDRED_EIGHTY = 180;
export const ONE_HUNDRED_NINETY = 190;
export const TWO_HUNDRED = 200;
export const TWO_HUNDRED_TEN = 210;
export const TWO_HUNDRED_TWENTY = 220;
export const TWO_HUNDRED_THIRTY = 230;
export const TWO_HUNDRED_FORTY = 240;
export const TWO_HUNDRED_FIFTY = 250;
export const FIFTY_TWO = 52;
export const FIFTY_FIVE = 55;
export const FIFTY_ONE = 51;
export const SEVENTY_EIGHT = 78;
export const SEVENTY = 70;
export const SEVENTY_SIX = 76;
export const ONE_HUNDRED_FIFTEEN = 115;
export const TWELVE = 12;
export const NINETY = 90;
export const NINETY_SIX = 96;
export const ONE_HUNDRED_SEVENTEEN = 117;

/* Use this when text on header is small */
export const TAILWIND_FOR_DATA_SMART_TABLE = {
	"[&_.toolbar-actions]:!right-0": true,
	"[&_.MuiDataGrid-filler>div]:!border-none": true,
	"[&_.toolbar-actions]:!mb-[0px]": true,
	"[&_.MuiDataGrid-iconSeparator]:!mt-[7px]": true,
	"[&_.MuiDataGrid-main]:!mt-[20px]": true,
};
export const FOOTER_PARAM_ID = "auto-generated-group-footer-root";
export const GROUP_NODE_ROOT_ID = "auto-generated-group-node-root";
export const HEADER_CLASS_NAME = "table-header-top-aligned";
export const TABLE_TOTAL_MARKER = "table-resume-totals";
export const TABLE_SMALL_HEADER = "table-small-header";
export const SHOW_AS_COLUMN = "show-as-column";
export const COMBINATED_CLASSES = `${HEADER_CLASS_NAME} ${TABLE_SMALL_HEADER} ${SHOW_AS_COLUMN} text-[#666666]`;
export const HEADER_CLASS_NAME_2 = `${COMBINATED_CLASSES} [&_.MuiDataGrid-columnHeaderTitle]:!text-[12px]`;
export const HEADER_ALIGN_RIGHT = " !text-right";
export const CELL_CLASS_ERROR = "table-cell-error table-cell-bold";
export const CELL_FONT_SIZE = "12px";
export const FOOTER_CELL_FONT_SIZE = "14px";
